export const KAZAAR_SUPPORT_URL = "https://support.kazaar.com";
